/* ==========================================================
   EARTH ENERGY | FRUITS & VEGGIES LP
   File: assets/ee-fv-lp.js
   Buy box logic, pricing math, add to cart, FAQ, sticky bar.
   Verified against live PDP 2026-07-09:
     1 Bottle  variant 41522579079337  plan 6203769085
     3 Pack    variant 41522579112105  plan 6203736317
     6 Pack    variant 41522579144873  plan 6203703549
   ========================================================== */
document.addEventListener("DOMContentLoaded", function () {
(function () {
  var PACKS = {
    "1": { variant: 41522579079337, plan: 6203769085, name: "1 Bottle", days: 30, bottles: 1,
           once: { price: 46.95, compare: null },
           sub:  { price: 37.56, compare: 46.95, renew: 39.91 } },
    "3": { variant: 41522579112105, plan: 6203736317, name: "3-Pack", days: 90, bottles: 3,
           once: { price: 109.95, compare: 140.85 },
           sub:  { price: 87.96, compare: 140.85, renew: 93.46 } },
    "6": { variant: 41522579144873, plan: 6203703549, name: "6-Pack", days: 180, bottles: 6,
           once: { price: 191.95, compare: 281.70 },
           sub:  { price: 153.56, compare: 281.70, renew: 163.16 } }
  };
  var IMGS = {
    "1": "https://www.earthenergysupplementstore.com/cdn/shop/files/FV_Front.webp?v=1774449338",
    "3": "https://www.earthenergysupplementstore.com/cdn/shop/files/F_V_New_3_Bottle.webp?v=1774449338",
    "6": "https://www.earthenergysupplementstore.com/cdn/shop/files/F_V_New_6_Bottle.webp?v=1774449338"
  };
  var state = { pack: "3", mode: "once" };
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return "$" + n.toFixed(2); };

  function render() {
    var p = PACKS[state.pack];
    var d = state.mode === "sub" ? p.sub : p.once;
    var perDay = d.price / p.days;
    var perBottle = d.price / p.bottles;

    $("eelp-price").textContent = money(d.price);
    if (d.compare) {
      $("eelp-was").style.display = "inline";
      $("eelp-was").textContent = money(d.compare);
      $("eelp-save").style.display = "inline";
      $("eelp-save").textContent = "You save " + money(d.compare - d.price);
    } else {
      $("eelp-was").style.display = "none";
      $("eelp-save").style.display = "none";
    }
    $("eelp-meta").textContent = money(perBottle) + " per bottle \u00B7 $" + perDay.toFixed(2) + " per day \u00B7 " + p.days + "-day supply";

    var note = $("eelp-subnote");
    if (state.mode === "sub") {
      note.style.display = "block";
      note.textContent = "Renews at " + money(p.renewPrice || d.renew) + " (15% off for life). Skip, swap, or cancel anytime.";
      $("eelp-atc").textContent = "Subscribe & Save 20%";
    } else {
      note.style.display = "none";
      $("eelp-atc").textContent = "Add to Cart";
    }

    $("eelp-main-img").src = IMGS[state.pack];
    $("eelp-sb-price").textContent = money(d.price);
    $("eelp-sb-meta").textContent = p.name + " \u00B7 $" + perDay.toFixed(2) + "/day";

    document.querySelectorAll("#eelp-packs .pack").forEach(function (el) {
      el.classList.toggle("on", el.getAttribute("data-pack") === state.pack);
    });
    document.querySelectorAll("#eelp-modes .mode").forEach(function (el) {
      el.classList.toggle("on", el.getAttribute("data-mode") === state.mode);
    });
    document.querySelectorAll("#eelp-packs .pack").forEach(function (el) {
      var pk = PACKS[el.getAttribute("data-pack")];
      var dd = state.mode === "sub" ? pk.sub : pk.once;
      el.querySelector('[data-role="pday"]').textContent = "$" + (dd.price / pk.days).toFixed(2) + "/day";
    });
  }

  document.querySelectorAll("#eelp-packs .pack").forEach(function (el) {
    el.addEventListener("click", function () { state.pack = el.getAttribute("data-pack"); render(); });
  });
  document.querySelectorAll("#eelp-modes .mode").forEach(function (el) {
    el.addEventListener("click", function () { state.mode = el.getAttribute("data-mode"); render(); });
  });
  document.querySelectorAll(".eelp .thumb").forEach(function (el) {
    el.addEventListener("click", function () {
      $("eelp-main-img").src = el.getAttribute("data-img");
      document.querySelectorAll(".eelp .thumb").forEach(function (t) { t.classList.remove("on"); });
      el.classList.add("on");
    });
  });

  $("eelp-atc").addEventListener("click", function () {
    var btn = this;
    var p = PACKS[state.pack];
    var item = { id: p.variant, quantity: 1 };
    if (state.mode === "sub") item.selling_plan = p.plan;
    btn.disabled = true;
    btn.textContent = "Adding...";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      window.location.href = "/checkout";
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = "Add to Cart";
      window.location.href = "/cart/add?id=" + p.variant + "&quantity=1" + (state.mode === "sub" ? "&selling_plan=" + p.plan : "");
    });
  });

  document.querySelectorAll(".eelp .faq-q").forEach(function (q) {
    q.addEventListener("click", function () { q.parentElement.classList.toggle("open"); });
  });

  var buy = document.getElementById("buy");
  var bar = $("eelp-sticky");
  window.addEventListener("scroll", function () {
    var past = buy.getBoundingClientRect().bottom < 0;
    bar.classList.toggle("show", past);
  }, { passive: true });

  document.querySelectorAll('.eelp a[href="#buy"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      buy.scrollIntoView({ behavior: "smooth" });
    });
  });

  render();
})();
});
